exports.components = {
  "component---src-components-aboutme-tsx": () => import("./../../../src/components/aboutme.tsx" /* webpackChunkName: "component---src-components-aboutme-tsx" */),
  "component---src-components-detail-tsx": () => import("./../../../src/components/detail.tsx" /* webpackChunkName: "component---src-components-detail-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

